<template>
  <div class="gjxx-list">
    <div class="email-sent f-l-center">
      <span class="theme-color">定制</span>
      <span>最新</span>
      <span class="theme-color key-words">&nbsp;"{{ listObj.title }}"&nbsp;</span>
      <span>发送至您的邮箱</span>
      <a :href="`${member_center_url}/register.html?a=1`" target="_blank">
        <img :src="`${imgPath}/oneold/layout/right.png`" alt="" class="right-img" />
      </a>
    </div>

    <div class="public-resource-list default-border mb--20 mt--20">
      <p class="title bb--default pb--20 pt--10">
        <span class="theme-color">{{ listObj.keyword }}</span>
        <span>共有</span>
        <span class="theme-color">{{ listObj.total }}</span>
        <span>条相关信息</span>
      </p>

      <!-- 列表内容 start -->
      <div class="list-con">
        <div v-if="listDataShow.length">
          <div v-for="(item, index) in listDataShow" :key="item.title + index" class="single bb--default">
            <a :href="item.url">
              <div class="one-line f-level-between">
                <div class="single-title">
                  <span v-html="item.title"></span>
                </div>
                <div class="f-layout right mr--10">
                  <div>
                    <i class="iconfont icon-shijian"></i>
                    <span>{{ item.inputtime }}</span>
                  </div>
                </div>
              </div>
              <div class="tag-box">
                <div class="tag-item">{{ item.progstr }}</div>
                <div class="tag-item">{{ item.areaName }}</div>
                <div class="tag-item tag-item-or" v-if="item.targetTag">{{ item.targetTag }}</div>
              </div>
              <div class="two-line ml--10">
                <p v-html="item.content"></p>
              </div>
            </a>
          </div>
        </div>
        <div v-else class="tip-block">
          <span>暂无数据</span>
        </div>
      </div>
      <!-- 列表内容 end -->

      <!-- 底部搜索 start -->
      <div class="bottom-search f-level-between mt--20 bt--default pt--20 pb--20">
        <img :src="`${imgPath}/oneold/layout/hsxm.gif`" alt="" class="can-click" @click="jumpSearch()" />
        <div class="right">
          <div class="search-block f-layout mb--10">
            <el-input v-model="searchInput" size="small" placeholder="请输入内容"></el-input>
            <el-button type="danger" size="small" @click="jumpSearch(searchInput)">搜索</el-button>
          </div>
          <p class="see-more can-click" @click="jumpSearch(listObj.keyword)">查看更多{{ listObj.keyword }}招标信息</p>
        </div>
      </div>
      <!-- 底部搜索 end -->
    </div>
  </div>
</template>
<script>
import { imgPath, VUE_APP_OLD_USER_CENTER_URL, SEARCH_URL } from "@/utils/constants/constants";
import { apiV1SemGetTargetsByCids } from "@/services/gjxx";
export default {
  name: "gjxxList",
  props: {
    listObj: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {},
  data() {
    return {
      member_center_url: VUE_APP_OLD_USER_CENTER_URL,
      searchInput: "",
      imgPath,
      progObj: [
        {
          id: 0,
          progText: "招标公告",
        },
        {
          id: 1,
          progText: "招标预告",
        },
        {
          id: 2,
          progText: "招标变更",
        },
        {
          id: 3,
          progText: "中标结果",
        },
      ],
      targetList: [],
      listDataShow: [],
    };
  },
  computed: {},
  watch: {
    listObj: {
      handler(val) {
        this.listDataShow = val.bodyData;
      },
      immediate: true,
      deep: true,
    },
    targetList: {
      handler(val) {
        let list = [];
        this.listDataShow.forEach((item) => {
          let data = val.find((i) => i.cid === item.contentid);
          let textData = this.progObj.find((itm) => itm.id === item.progid);
          if (!item.progstr) {
            item.progstr = textData.progText;
          }
          item = {
            ...item,
            ...data,
          };
          list.push(item);
        });
        this.listDataShow = list;
      },
      immediate: true,
      deep: true,
    },
  },
  created() {},
  mounted() {
    // this.getTargetsByCids();
  },
  methods: {
    jumpSearch(val) {
      window.open(SEARCH_URL + "/?q=" + val);
    },
    getProgText(progid) {
      return this.progObj.find((item) => item.id === progid);
    },
    async getTargetsByCids() {
      if (!this.listObj.cids) return;
      const res = await apiV1SemGetTargetsByCids({ cids: this.listObj.cids }).then((res) => res.data);
      this.targetList = res;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/variable.scss";
.gjxx-list {
  .public-resource-list {
    box-sizing: border-box;
    padding: 20px;
  }

  .title {
    font-size: 14px;
    font-weight: bold;
  }

  .list-con {
    .single {
      padding: 20px 0;
      &:last-child {
        border: none;
      }
    }

    .single-title {
      // width: 70%;
      font-size: 14px;
      font-weight: bold;
      @include line-ellipsis(1);
      &:hover {
        color: $theme-color;
        text-decoration: underline;
      }
    }

    .one-line {
      align-items: center;
      margin-bottom: 16px;
    }
    .tag-box {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .tag-item {
        border-radius: 3px;
        padding: 2px 10px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 550;
        color: #1687ff;
        background: #eff6ff;
        margin-right: 8px;
        line-height: 16px;
        &.tag-item-or {
          color: #ff643d;
          background: #fff2ee;
        }
      }
    }
    .two-line {
      word-break: break-all;
      color: #666666;
      line-height: 24px;
    }

    .icon-img {
      width: 14px;
      height: 14px;
      vertical-align: middle;
    }

    .right {
      color: #999999;
      font-size: 14px;
      display: flex;
      justify-content: flex-end;
      width: 125px;
      flex-shrink: 0;
      i {
        font-size: 14px;
        padding-right: 5px;
      }
    }
  }

  .tip-block {
    padding: 30px 0;
    text-align: center;
  }

  .bottom-search {
    .see-more {
      text-align: right;
    }

    .can-click {
      cursor: pointer;
    }
  }

  .email-sent {
    height: 40px;
    background: #f5f5f5;
    border: 1px solid #e5e5e5;
    font-size: 14px;
    align-items: center;

    .key-words {
      font-weight: bold;
    }

    .right-img {
      width: 20px;
      height: 20px;
      margin-left: 10px;
    }
  }
}
</style>
